import { CRM_WEB_PAGES_URLS } from '../../CRM_WEB_PAGES_URLS';
import { ADMIN_WEB_PAGES_URLS } from '../../EMR_WEB_PAGES_URLS';
import { PATIENT_WEB_PAGES_URLS } from '../../PATIENT_WEB_PAGES_URLS';
import { usStates } from '../../data';
import { OrganizationSettings } from '@care-portals/api-interfaces';

export const goodnatal: OrganizationSettings = {
  name: 'Goodnatal',
  fromEmail: 'hello@goodnatal.com',
  replyToEmail: 'hello@goodnatal.com',
  forgotPasswordTemplateId: '6491bfd244a33598f94214ea',
  verifyAccountTemplateId: '6484b3fab8820c08aa9d8df2',
  ecommerceEnabled: false,
  stripeEnabled: true,
  conversationServiceId: 'IS9d8b15500b914f3a98bff0a083e18592',
  patientPortalDomain: 'goodnatal.portals.care',
  crmWebAppLayout: {
    title: 'Goodnatal',
    logo: 'https://uploads-ssl.webflow.com/64d5b4760b225ea1401b601b/64da77cec9e310aeb8f207b7_goodnatal%20logo%20gradient-p-500.png',
    // locations: [
    //   { value: 'PSYPACT', label: 'PsyPact' },
    //   { value: 'FL', label: 'Florida' }
    // ],
    mainMenu: [
      {
        title: 'Appointments',
        link: CRM_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fas fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Leads',
        link: CRM_WEB_PAGES_URLS.leads.list,
        icon: 'fas fa-user',
        roles: ['*']
      },
      {
        title: 'Tasks',
        link: CRM_WEB_PAGES_URLS.tasks.list,
        icon: 'fas fa-tasks',
        roles: ['*']
      },
      {
        title: 'Segments',
        link: CRM_WEB_PAGES_URLS.segment.list,
        icon: 'fas fa-columns',
        roles: ['*']
      },
      {
        title: 'Store Manager',
        link: '',
        icon: 'fas fa-shop',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Products',
            link: CRM_WEB_PAGES_URLS.products.list,
            icon: 'fas fa-product'
          },
          {
            title: 'Coupons',
            link: CRM_WEB_PAGES_URLS.coupons.list,
            icon: 'fas fa-gift'
          },
          {
            title: 'Promotions',
            link: CRM_WEB_PAGES_URLS.promotions.list,
            icon: 'fas fa-gift'
          }
        ]
      },
      {
        title: 'Admin',
        link: '',
        icon: 'fas fa-user-cog',
        roles: ['admin', 'developer', 'owner'],
        items: [
          {
            title: 'Services',
            link: CRM_WEB_PAGES_URLS.services.list,
            icon: 'fas fa-medkit'
          },
          {
            title: 'Schedules',
            link: CRM_WEB_PAGES_URLS.schedules.list,
            icon: 'fas fa-calendar'
          },
          {
            title: 'Segments',
            link: CRM_WEB_PAGES_URLS.segment.list,
            icon: 'fa-solid fa-table-columns'
          },
          {
            title: 'Campaigns',
            link: CRM_WEB_PAGES_URLS.campaigns.list,
            icon: 'fas fa-paper-plane'
          },
          {
            title: 'Recurring Tasks',
            link: CRM_WEB_PAGES_URLS.recurringTasks.list,
            icon: 'fas fa-recycle'
          },
          {
            title: 'Users',
            link: CRM_WEB_PAGES_URLS.users.list,
            icon: 'fas fa-lock'
          },
          {
            title: 'Forms',
            link: CRM_WEB_PAGES_URLS.forms.list,
            icon: 'fas fa-table'
          },
          {
            title: 'Workflows',
            link: CRM_WEB_PAGES_URLS.workflows.list,
            icon: 'fas fa-code-branch'
          },
          {
            title: 'Templates',
            link: CRM_WEB_PAGES_URLS.emailTemplates.list,
            icon: 'fas fa-palette'
          },
          {
            title: 'Settings',
            link: CRM_WEB_PAGES_URLS.settings.base,
            icon: 'fas fa-gear'
          }
        ]
      }
    ]
  },
  emrWebAppLayout: {
    title: 'Goodnatal',
    defaultPingMsg:
      '🛎️ Ping! Goodnatal care team is waiting for your response. To respond, please go to https://goodnatal.portals.care/messages',
    mainMenu: [
      {
        title: 'Patients',
        name: 'patients',
        link: ADMIN_WEB_PAGES_URLS.customers.allList,
        icon: 'fas fa-user-injured',
        roles: ['*']
      },
      {
        title: 'Appointments',
        link: ADMIN_WEB_PAGES_URLS.appointments.calendar,
        icon: 'fas fa-calendar-check',
        roles: ['*']
      },
      {
        title: 'Purchases',
        name: 'purchases',
        link: ADMIN_WEB_PAGES_URLS.orders.allList,
        icon: 'fas fa-shopping-cart',
        roles: ['admin', 'owner', 'user']
      }
    ],
    // customerTabs: [
    //   'consults',
    //   'appointments',
    //   'invoices',
    //   'notes',
    //   'files',
    //   'payment-methods'
    // ],
    questionnaires: [
      'gn_welcome',
      'gn_intake',
      'gn_post_session',
      'gn_blood_results',
      'epds',
      'phq9',
      'gad7',
      'consent'
    ]
  },
  patientWebAppLayout: {
    title: 'Goodnatal',
    brand: 'goodnatal',
    shopUrl: 'https://www.goodnatal.com/shop',
    topAction: {
      title: 'Book Now',
      link: 'https://www.goodnatal.com/booking?email=${email}'
    },
    logo: {
      img: 'https://uploads-ssl.webflow.com/64d5b4760b225ea1401b601b/64da77cec9e310aeb8f207b7_goodnatal%20logo%20gradient-p-500.png',
      link: 'https://goodnatal.com'
    },
    gtm: {
      id: 'GTM-M7HWTJT8'
    },
    referrals: {
      enabled: false,
      referrerAmount: 50,
      refereeAmount: 30,
      referralURI: 'https://goodnatal.portals.care/auth/signup',
      referralFAQ: 'https://www.goodnatal.com/referral-rewards/'
    },
    privacyPolicyUrl: 'https://www.goodnatal.com/privacy-policy',
    termsOfUseUrl: 'https://www.goodnatal.com/terms-of-use',
    stripePublicKey: 'pk_live_PcAvLR7KASvRX4ZWxo7f6c7B00FNmsB7Lx',
    mainMenu: [
      {
        title: 'Appointments',
        link: PATIENT_WEB_PAGES_URLS.account.appointments,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bf1b9079853dd9b9d9_appointments.svg',
        roles: ['*']
      },
      {
        title: 'Questionnaires',
        link: PATIENT_WEB_PAGES_URLS.account.questionnaires,
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/6474fa78506b37e70b798189_Form.svg',
        roles: ['*']
      },
      {
        title: 'Community',
        link: 'https://www.facebook.com/groups/goodnatalrecurrentloss/',
        type: 'external',
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bfc2cbcbab683e36ae_courses.svg',
        roles: ['*']
      },
      {
        title: 'Billing',
        link: 'billing',
        svg: 'https://uploads-ssl.webflow.com/640f9228c4417a7d888139b2/647394bf1599f3a16bdf2b6a_billing.svg',
        type: 'external',
        roles: ['*']
      }
    ],
    availableStates: {
      us: [...usStates]
    }
  }
};
